import { render, staticRenderFns } from "./MenubindaccountDialog.vue?vue&type=template&id=39723a51&scoped=true"
import script from "./MenubindaccountDialog.vue?vue&type=script&lang=js"
export * from "./MenubindaccountDialog.vue?vue&type=script&lang=js"
import style0 from "./MenubindaccountDialog.vue?vue&type=style&index=0&id=39723a51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39723a51",
  null
  
)

export default component.exports